"use strict";

import angular from "angular";

import template from "./shared-email-reports.component.html";
import "./themes/shared-email-reports-dark.component.scss";
import "./themes/shared-email-reports.component.scss";

import _ from "lodash";
export class sharedEmailComponent {
    constructor($mdConstant, $scope) {
        this.$mdConstant = $mdConstant;
        this.$scope = $scope;
        this.chipInput = {
            users: [],
            readonly: false,
            removable: true
        };
        this.validates = {
            email: ""
        };
        this.keys = [
            this.$mdConstant.KEY_CODE.ENTER,
            this.$mdConstant.KEY_CODE.SPACE
        ];
        this.invalidEmail = false;
        this.selected = false;
        this.usersVis = "";
        this.filterSelected = [];
        this.usersAnonymous = [];
        this.updateStatus = false;
    }

    $onChanges(changes) {
        if (changes.users && !changes.users.isFirstChange()) {
            this.$scope.$applyAsync();
        }
    }

    _flattenUsers() {
        if (!this.users) return [];
        if (Array.isArray(this.users)) return this.users;
        return _.flatten(Object.values(this.users));
    }

    async onChangeListed() {
        const registeredUsers = this._flattenUsers();
        this.usersAnonymous = this.chipInput.users;
        this.filterSelected = _.filter(registeredUsers, (u) => u.selected);
        let users = _.filter(registeredUsers, (u) => u.selected)
            .map((user) => {
                return (
                    _.get(user, "profile.nickname") ||
                    _.get(user, "profile.name") ||
                    user.name
                );
            })
            .concat(this.chipInput.users);
        if (this.company && this.company.isGroup) {
            for (let group of this.group || []) {
                users = users.concat(
                    group.users.filter((u) => u.selected).map((u) => u.username)
                );
            }
        }
        if (!this.chipInput.users.length) this.invalidEmail = false;
        if (!this.updateStatus) {
            if (this.chipInput.users.length)
                await this.checkEmail(
                    this.chipInput.users[this.chipInput.users.length - 1],
                    users
                );
        }
        if (!this.invalidEmail)
            this.selected =
                this.chipInput.users.length || this.filterSelected.length
                    ? true
                    : false;
        if (this.company && this.company.isGroup) {
            const allUsersGroup = (this.group || []).map((g) => {
                return {
                    ...g,
                    selected:
                        g.users.filter((u) => u.selected).length > 0
                            ? true
                            : false
                };
            });
            if (allUsersGroup.filter((g) => g.selected).length > 0)
                this.selected =
                    allUsersGroup.filter((g) => g.selected).length > 0
                        ? true
                        : false;
        }
        this.updateStatus = false;
        this.usersVis = users;
    }

    checkEmail = async (email, users) => {
        let timeoutInvalid = null;
        this.validates.email = email;
        const regexEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$/g;
        if (regexEmail.test(email)) {
            this.invalidEmail = false;
            this.updateStatus = true;
            this.selected = true;
            this.onChangeListed();
            return false;
        }
        this.invalidEmail = true;
        clearTimeout(timeoutInvalid);
        timeoutInvalid = setTimeout(() => {
            this.invalidEmail = false;
        }, 1000 * 2);
        this.updateStatus = true;
        this.selected = false;
        this.onChangeListed();
        this.chipInput.users.pop();
        if (this.chipInput.users.length || this.filterSelected.length)
            this.selected = true;
        users.pop();
        return true;
    };
}

sharedEmailComponent.$inject = ["$mdConstant", "$scope"];

const name = "sharedEmailReports";
const def = {
    bindings: {
        users: "<",
        commentEmail: "=",
        selected: "=",
        usersAnonymous: "=",
        group: "=",
        company: "<"
    },
    controller: sharedEmailComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
